<template>
  <modal :show="show" :showLarge=true>
    <div slot="modalHeader">
      <modal-header :closeModal="customClose">Alter AE Creative to New </modal-header>
      <spinner-icon v-if="loading" />
    </div>
    <notifications :messages="notifications" v-if="notifications && notifications.length > 0"/>
      <steps v-if="step <= 4" :options="steps.options" :active="step === 4 && !steps.options.includes('Fonts & Plugins') ? step : step+1" />
        <div v-if="step === 0">
            <form-group>
                <field name="Name" v-model="newCreative.name" :error="errors.creativeName"/>
            </form-group>
            <form-group>
                <field name="Creative Job Number (Optional)" v-model="newCreative.creative_job_number" />
            </form-group>
            <form-group>
                <div class="text-danger"><br />Uploading AEPX files will enable error checking within the upload process.</div>
            </form-group>
            <upload-file name="Master File" :ctaText="uploadText" @input="onUploadFile" acceptedFileType="" :error="errors.creativeFile" />
        </div>
        <!-- compositions -->
        <div v-else-if="step === 1">
            <form-group class="composition-block">
              <field name="Add composition names" v-model="composition" :error="errors.compositions"/>
              <button-cta :onClick="addComposition" :class="[errors.compositions !== '' ? 'margin-auto' : '']">Add</button-cta>
            </form-group>
            <div v-if="compositions.length > 0" class="listing-wrapper">
                <div class="step-listing" v-for="(composition, itr) in compositions" :key="itr">
                    <field v-if="compositionEditing === itr" v-model="compositions[itr]" :error="errors.compositions"/>
                    <p v-else>{{composition}}</p>
                    <div>
                    <button-cta v-if="compositionEditing === itr" class="btn-xs btn btn-success" :onClick="() => stopEditingComposition(itr)">
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </button-cta>
                    <button-cta v-else-if="compositionEditing === null" class="btn-xs btn btn-primary" :onClick="() => editComposition(itr)">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button-cta>
                    <button-cta class="btn btn-danger btn-xs btn btn-primary" :onClick="() => deleteComposition(itr)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button-cta>
                    </div>
                </div>
            </div>
            <upload-file @input="onUploadConfig" name="Config Json File" :ctaText="uploadConfig" acceptedFileType="application/csv/json/xml" :error="errors.creativeFile" />
        </div>
        <!-- layers -->
        <div v-else-if="step === 2">
            <form-group class="variable-element-wrapper">
              <div class="d-flex variable-element composition-block">
                <field name="Layer name in your comps" placeholder="Headline 1" v-model="layerName" />
                <field name="Add Default Text or Filename" placeholder="Default Value" v-model="layerValue" />
                <dropdown :current="layerTypesOptions()[0].name" name="Type" :options="layerTypesOptions()" v-model="layerType" />
                <button-cta class="buttun-margin" :onClick="addLayer">Add</button-cta>
              </div>
              <span v-if="errors.layers" class="text-danger">{{ errors.layers}}</span>
            </form-group>
            <div>
              <table class="table no-bordered">
                <tbody>
                  <tr v-for="(layer, itr) in layers" :key="itr">
                    <td :style="{width: '30%'}" v-if="layerEditing === itr">
                      <field placeholder="Headline 12" v-model="layers[itr].name" />
                    </td>
                    <td :style="{width: '30%'}" v-else><field placeholder="Headline 12" disabled v-model="layer.name" /></td>
                    <td :style="{width: '30%'}" v-if="layerEditing === itr">
                      <field placeholder="Default Value" v-model="layers[itr].value" />
                    </td>
                    <td :style="{width: '30%'}" v-else><field placeholder="Headline 12" disabled v-model="layer.value" /></td>
                    <td :style="{width: '30%'}" v-if="layerEditing === itr">
                      <dropdown :options="layerTypesOptions()" :current="capitalize(layer.type)" v-model="layers[itr].type" />
                    </td>
                    <td :style="{width: '30%'}" v-else><field placeholder="Headline 12" disabled v-model="layer.type" /></td>
                    <td align="right" :style="{display: 'flex',width: '30%'}">
                      <button-cta :style="{marginTop: '0.5rem'}" v-if="layerEditing === itr" class="btn-xs btn btn-success" :onClick="() => stopEditingLayer(itr)">
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </button-cta>
                      <button-cta :style="{marginTop: '0.5rem'}" v-else-if="layerEditing === null" class="btn-xs btn btn-primary" :onClick="() => editlayer(itr)">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </button-cta>
                      <button-cta :style="{marginTop: '0.5rem', marginInline: '0.1rem'}" class="btn btn-danger btn-xs btn btn-primary" :onClick="() => deleteLayer(itr)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button-cta>
                    </td>
                  </tr>
                </tbody>
              </table>
              <upload-file @input="onUploadlayer" name="Layer Json File" :ctaText="uploadLayer" acceptedFileType="application/csv/json/xml" :error="errors.creativeFile" />
            </div>
        </div>
      <div v-else-if="step === 3">
        <span>If this project requires any plugins or fonts that have not been previously supplied to us, please contact us at <a href="mailto:techsupport@otomo.io">techsupport@otomo.io</a></span>
      </div>
      <div v-else-if="step === 4">
        <creative-table :tableData="formattedCreative.fields" v-model="formattedCreative.fields" @onToggleParentCheckboxes="updateCheckboxData" :type="newCreative.type" />
      </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="customClose" :confirm="save" :back="back" :showBack="showBack()" :hideCancelText="step !== 0 || step === 4" :confirmText="step === 4 ? 'Complete' : 'Next'"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import UploadFile from '@/components/UploadFile/upload-file'
import {assoc, find, map, omit, propEq} from 'ramda'
import Steps from '@/components/Steps/steps'
import CreativeTable from '@/components/CreativeTable/creative-table'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'
import Notifications from '@/components/Notifications/notifications'

import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_alter_ae_creative',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field,
    UploadFile,
    Dropdown,
    Steps,
    CreativeTable,
    SpinnerIcon,
    Notifications
  },
  props: {
    show: Boolean,
    goToStep: {
      type: Number,
      default: 0
    },
    confirmId: String
  },
  data: () => ({
    selectedCreative: null,
    step: 0,
    steps: {
      options: ['Creative', 'Composition', 'Layers', 'Fields']
    },
    uploadText: 'Upload',
    files: null,
    newCreative: {
      name: '',
      type: 'after-effects',
      creative_job_number: ''
    },
    composition: '',
    compositions: [],
    compositionIsEditing: null,
    layers: [],
    layerName: '',
    layerValue: '',
    layerType: 'text',
    layerIsEditing: null,
    errors: {
      creativeName: '',
      creativeFile: '',
      compositions: '',
      encodingProfiles: '',
      layers: ''
    },
    layersChange: false,
    compositionsChange: false
  }),
  watch: {
    show (newValue, oldValue) {
      if (!this.show) {
        this.step = 0
        this.uploadText = 'Upload'
        this.files = null
      } else {
        this.getCreative()
      }
    }
  },
  computed: {
    formattedCreative () {
      const newCreative = this.newCreative
      newCreative.fields = map(item => assoc('editableActions', true, item), this.newCreative.fields)
      return newCreative
    },
    compositionEditing () {
      return this.compositionIsEditing
    },
    layerEditing () {
      return this.layerIsEditing
    }
  },
  methods: {
    getCreative () {
      if (this.creatives) {
        this.selectedCreative = find(propEq('hash_id', this.confirmId), this.creatives)
        if (this.selectedCreative) {
          this.newCreative.name = this.selectedCreative.name
          this.newCreative.creative_job_number = this.selectedCreative.creative_job_number
          return this.selectedCreative
        }
      }
    },
    save () {
      let creativeErrors = 0
      this.resetNotifications()
      this.resetErrors()
      this.layerIsEditing = null
      this.compositionIsEditing = null
      if (this.step === 0) {
        if (this.newCreative.name === '') {
          this.errors.creativeName = 'This value should not be blank.'
          creativeErrors++
        }
        if (!this.files) {
          this.errors.creativeFile = 'You need to upload a master file.'
          creativeErrors++
        }
        if (creativeErrors) {
          return false
        }
        this.moveNext()
        this.loadCompositionsFromCreative()
      } else if (this.step === 1) {
        if (!this.compositions.length) {
          this.errors.compositions = 'This value should not be blank.'
          return false
        }
        this.moveNext()
        this.loadlayersFromCreative()
      } else if (this.step === 2) {
        if (!this.layers.length) {
          this.errors.layers = 'This value should not be blank.'
          return false
        }
        this.layersChange = this.isLayersChange()
        this.compositionsChange = this.isCompositionsChange()
        if (this.layersChange || this.compositionsChange) {
          if (!this.steps.options.includes('Fonts & Plugins')) {
            this.steps.options.splice(3, 0, 'Fonts & Plugins')
            console.log(this.steps.options)
          }
          this.moveNext()
        } else {
          this.saveCreative()
          this.moveNext(2)
        }
      } else if (this.step === 3) {
        this.saveCreative()
        this.moveNext()
      } else if (this.step === 4) {
        this.completeCreative('complete')
      }
    },
    isLayersChange () {
      if (this.selectedCreative) {
        if (this.selectedCreative.fields.length !== this.layers.length) {
          return true
        }
      }
      return false
    },
    isCompositionsChange () {
      if (this.selectedCreative) {
        if (this.selectedCreative.compositions.length !== this.compositions.length) {
          return true
        }
      }
      return false
    },
    onUploadFile (e) {
      this.uploadText = 'Upload'
      this.errors.creativeFile = ''
      const files = e.target.files || e.dataTransfer.files
      if (files.length > 0) {
        if (!this.validateFile(files[0])) {
          this.errors.creativeFile = `Only AEPX and AEP files are allowed.`
          return
        }
      }
      this.uploadText = e.target.files[0].name
      this.files = files
    },
    validateFile (file) {
      const allowedExtensions = ['.aep', '.aepx']
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase()
      return allowedExtensions.includes(fileExtension)
    },
    loadCompositionsFromCreative () {
      if (this.selectedCreative) {
        this.selectedCreative.compositions.forEach(composition => {
        // ignore duplicates
          if (!this.compositions.includes(composition)) {
            this.compositions.push(composition)
          }
        })
      }
    },
    addComposition () {
      //   this.resetErrors()
      let existingValue = this.compositions.find(item => item === this.composition)
      if (existingValue) {
        this.errors.compositions = 'No Duplicates Compositions allowed'
        return
      }
      if (this.composition == null || this.composition === '') {
        this.errors.compositions = 'This value should not be blank.'
        return
      }
      this.compositions.push(this.composition)
      this.composition = null
    },
    editComposition (itr) {
      this.compositionIsEditing = itr
    },
    stopEditingComposition (itr) {
      if (this.compositions[itr] == null || this.compositions[itr] === '') {
        this.errors.compositions = 'This value should not be blank.'
        return
      }
      let itemsCount = this.compositions.length
      let otherCompositions = this.compositions.filter(item => item !== this.compositions[itr])
      if (itemsCount - 1 !== otherCompositions.length) {
        this.errors.compositions = 'No Duplicates Composition Names allowed'
        return
      }
      //   this.resetErrors()
      this.compositionIsEditing = null
    },
    deleteComposition (itr) {
      this.compositions = this.compositions.filter((o, i) => itr !== i)
    },
    onUploadConfig (e) {
      const config = e.target.files[0]
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        const configObj = JSON.parse(e.target.result)
        configObj.compositions.forEach(composition => {
          // ignore duplicates
          if (!this.compositions.includes(composition)) {
            this.compositions.push(composition)
          }
        })
      }
      fileReader.readAsText(config)
    },
    loadlayersFromCreative () {
      if (this.selectedCreative) {
        this.selectedCreative.fields.forEach(layer => {
          const type = layer.type === 'string' ? 'text' : layer.type
          const newLayer = {name: layer.name, value: layer.defaultValue, type: type}
          // ignore duplicates
          if (!this.isLayerExists(newLayer)) {
            this.layers.push(newLayer)
          }
        })
      }
    },
    addLayer () {
      this.resetErrors()
      if (!this.layerName) {
        this.errors.layers = 'Layer Name should not be blank.'
        return
      }
      if (!this.layerValue) {
        this.errors.layers = 'Layer Value should not be blank.'
        return
      }
      if (!this.layerType) {
        this.errors.layers = 'Layer Type should not be blank.'
        return
      }
      let existingValue = this.layers.find(item => item.name === this.layerName)
      if (existingValue) {
        this.errors.layers = 'No Duplicates Layer Name allowed'
        return
      }
      let newLayer = {
        name: this.layerName,
        value: this.layerValue,
        type: this.layerType
      }
      this.layers.push(newLayer)
      this.layerName = null
      this.layerValue = null
    },
    editlayer (itr) {
      this.layerIsEditing = itr
    },
    stopEditingLayer (itr) {
      let otherLayers = this.layers.filter(item => item !== this.layers[itr])
      let existingValue = otherLayers.find(item => item.name === this.layers[itr].name)
      if (existingValue) {
        this.errors.layers = 'No Duplicates Layer Name allowed'
        return false
      }
      if (!this.layers[itr].name) {
        this.errors.layers = 'Layer Name should not be blank.'
        return false
      }
      if (!this.layers[itr].value) {
        this.errors.layers = 'Layer Value should not be blank.'
        return false
      }
      if (!this.layers[itr].type) {
        this.errors.layers = 'Layer Type should not be blank.'
        return false
      }
      this.resetErrors()
      this.layerIsEditing = null
    },
    deleteLayer (itr) {
      this.layers = this.layers.filter((o, i) => itr !== i)
    },
    isLayerExists (layer) {
      return this.layers.find(item => item.name === layer.name && item.value === layer.value && item.type === layer.type)
    },
    onUploadlayer (e) {
      const layerFile = e.target.files[0]
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        const layerObj = JSON.parse(e.target.result)
        for (const layerAndKeys of Object.entries(layerObj)) {
          if (layerAndKeys[0] === 'otomo-layers') {
            for (const [key, layer] of Object.entries(layerAndKeys[1])) {
              const newLayer = {name: key, value: layer.defaultValue, type: layer.type}
              if (!this.isLayerExists(newLayer)) {
                this.layers.push(newLayer)
              }
            }
          }
        }
      }
      fileReader.readAsText(layerFile)
    },
    layerTypesOptions () {
      const optionsArray = []
      let data = [
        'Text',
        'Image',
        'Video',
        'Audio'
      ]
      data.forEach((d) => {
        const option = {
          name: d,
          value: d
        }
        optionsArray.push(option)
      })
      return optionsArray
    },
    customClose () {
    //   if (this.step === 4) {
    //     this.completeCreative('close')
    //   } else {
      this.close()
    //   }
    },
    back () {
      this.step -= 1
    },
    showBack () {
      return this.step > 0 && this.step < 4
    },
    capitalize (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    resetErrors () {
      this.errors.creativeName = ''
      this.errors.creativeFile = ''
      this.errors.compositions = ''
      this.errors.encodingProfiles = ''
      this.errors.layers = ''
      this.errors.plugins = ''
      this.errors.fonts = ''
    },
    moveNext (steps = 1) {
      this.step += steps
    },
    completeCreative (action) {
      this.startLoading()
      const updateCreative = omit(['campaign', 'date_created', 'date_updated', 'type', 'units', 'editableActions'], this.formattedCreative)
      this.updateCreative(updateCreative).then(() => {
        if (action === 'complete') {
          console.log('pushing if')
          this.$router.push(`/creatives/${updateCreative.hash_id}/bulk`)
        } else {
          console.log('pushing else')
          this.$router.push(`/creatives/${updateCreative.hash_id}/bulk`) // TODO Push to current page
        }
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    },
    saveCreative () {
      let creativeErrors = 0

      this.resetErrors()

      if (this.newCreative.name === '') {
        this.errors.creativeName = 'This value should not be blank.'
        creativeErrors++
      }
      if (!this.files) {
        this.errors.creativeFile = 'You need to upload a master file.'
        creativeErrors++
      }

      if (creativeErrors) {
        return
      }

      this.startLoading()
      const formData = new FormData()
      formData.append('name', this.newCreative.name)
      formData.append('alter_creative_hash', this.selectedCreative.hash_id)
      formData.append('type', this.newCreative.type)
      formData.append('creative_job_number', this.newCreative.creative_job_number)
      formData.append('campaign', this.selectedCreative.campaign.hash_id)
      formData.append('file', this.files[0])
      formData.append('compositions', JSON.stringify(this.compositions))
      formData.append('composition', this.compositions[0])
      formData.append('encoding_profiles', JSON.stringify(this.selectedEncodingProfiles))
      formData.append('layers', JSON.stringify(this.layers))
      formData.append('plugins', JSON.stringify(this.selectedPlugins))
      formData.append('fonts', JSON.stringify(this.selectedFonts))

      this.addCreative(formData).then((creative) => {
        this.newCreative = creative
        const masters = {}
        const payload = {
          id: creative.hash_id,
          columns: ['id', 'master', 'locale', 'width', 'height'],
          unit: [],
          index6: true
        }
        creative.masters.forEach(master => {
          masters[master.name] = {
            values: [this.uniqueId(), master.name, master.name, master.width, master.height]
          }
        })
        creative.fields.forEach(field => {
          payload.columns.push(field.name)
          for (const master in masters) {
            let value = ''
            if (field.default_values !== null) {
              field.default_values.forEach(defaultValue => {
                if (defaultValue.master === master) {
                  value = defaultValue.value
                }
              })
            }
            value = field.defaultValue
            masters[master].values.push(value)
          }
        })
        for (const master in masters) {
          payload.unit.push(masters[master].values)
        }
        this.updateCreativeUnit(payload).then(() => {
          this.addNotification('success', 'Creative successfully created.')
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        if (error.includes('Composition Error')) {
          this.step = 1
        } else if (error.includes('Layer Error')) {
          this.step = 2
        }
        this.finishLoading()
        this.addNotification('danger', error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-alter-ae-creative.vue